const sortOrders = {
    ASC: 'asc',
    DESC: 'desc',
}

export default sortOrders